<template>
  <div>
    <p class="component-title-help">独立模块小标题，可单独搭配图表、地图和列表。设备在线情况不再内置标题，直接用本组件搭配。</p>
    <el-form-item label="标题内容"><el-input :value="main.activeOption.text" maxlength="200" aria-label="组件标题内容" @input="$set(main.activeOption, 'text', $event)" /></el-form-item>
    <el-form-item label="字体大小"><avue-input-number v-model="main.activeOption.fontSize" :min="10" :max="100" /></el-form-item>
    <el-form-item label="文字字体"><avue-select v-model="main.activeOption.fontFamily" :dic="dicOption.fontFamily" /></el-form-item>
    <el-form-item label="文字粗细"><el-select :value="main.activeOption.fontWeight" aria-label="组件标题文字粗细" @input="$set(main.activeOption, 'fontWeight', $event)"><el-option :value="400" label="常规" /><el-option :value="500" label="中等" /><el-option :value="600" label="半粗（默认）" /><el-option :value="700" label="加粗" /></el-select></el-form-item>
    <el-form-item label="文字颜色"><avue-input-color v-model="main.activeOption.color" /></el-form-item>
    <el-form-item label="左侧竖线"><el-switch :value="main.activeOption.showMarker !== false" aria-label="显示标题左侧竖线" @input="$set(main.activeOption, 'showMarker', $event)" /></el-form-item>
    <template v-if="main.activeOption.showMarker !== false">
      <el-form-item label="竖线颜色"><avue-input-color v-model="main.activeOption.markerColor" /></el-form-item>
      <el-form-item label="竖线宽度"><avue-input-number v-model="main.activeOption.markerWidth" :min="1" :max="10" /></el-form-item>
      <el-form-item label="文字间距"><avue-input-number v-model="main.activeOption.markerGap" :min="0" :max="32" /></el-form-item>
    </template>
    <el-form-item label="背景颜色"><avue-input-color v-model="main.activeOption.backgroundColor" /></el-form-item>
    <p class="component-title-help">默认透明背景，不包含边框、底线或顶部装饰。长标题省略显示，鼠标停留可查看全文。</p>
  </div>
</template>
<script>
import { dicOption } from '@/option/config'

export default { inject: ['main'], data: () => ({ dicOption }) }
</script>
<style scoped>
.component-title-help { color: #a4b6c5; font-size: 12px; line-height: 1.6; margin: 0 0 12px; overflow-wrap: anywhere; }
</style>
